import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useReferralsEnabled } from 'hooks/api/useFeatures'
import { ROUTES } from 'routes'

/**
 * VRG-680 — `/settings/referrals` exists only while the Refer & earn launch switch is on.
 *
 * Off → redirect to Settings (replace, so Back does not bounce the user into it again).
 * Unknown (the first `/features` fetch) → render nothing rather than the page: the page
 * would otherwise mount, call `/referrals/admin/*` and draw an error for a programme that
 * is not live. The sidebar reads the same query on every page, so in practice the answer
 * is already cached by the time anyone navigates here.
 */
export const RequireReferralsEnabled = ({ children }: { children: ReactNode }) => {
  const { enabled, isKnown } = useReferralsEnabled()
  if (!isKnown) return null
  if (!enabled) return <Navigate to={ROUTES.SETTINGS} replace />
  return <>{children}</>
}
